import { gql } from "@apollo/client";

export const Get_Total_Leads = gql`
  query GetTotalLeads($where: LeadsGeneratedFilterInput) {
    leadsGeneratedReport(where: $where) {
      totalCount
    }
  }
`;

export const Get_Email_Sent = gql`
  query GetEmailSent($where: EmailSentFilterInput) {
    emailSentReport(where: $where) {
      totalCount
    }
  }
`;
export const Get_SMS_Sent = gql`
  query GetSmsSent($where: SMSSentFilterInput) {
    smsSentReport(where: $where) {
      totalCount
    }
  }
`;
export const Get_Email_Recevied = gql`
  query GetEmailReceived($where: EmailReceivedFilterInput) {
    emailReceivedReport(where: $where) {
      totalCount
    }
  }
`;
export const Get_SMS_Recevied = gql`
  query GetSmsReceived($where: SMSReceivedFilterInput) {
    smsReceivedReport(where: $where) {
      totalCount
    }
  }
`;

export const Get_Inbound_Calls = gql`
  query GetVoiceCallReport($where: VoiceCallFilterInput) {
    voiceCallReport(where: $where) {
      totalCount
    }
  }
`;

export const Get_Automation_Usage = gql`
  query AutomationUsageKPI($from: DateTime!, $to: DateTime!) {
    automationUsageKpi(fromDate: $from, toDate: $to) {
      totalLeads
      usagePercentage
      leadsInActiveAutomations
    }
  }
`;

export const Get_Total_Leads_Count = gql`
  {
    leads {
      totalCount
    }
  }
`;
